import { render, staticRenderFns } from "./search.vue?vue&type=template&id=dee183b4&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dee183b4')) {
      api.createRecord('dee183b4', component.options)
    } else {
      api.reload('dee183b4', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=dee183b4&", function () {
      api.rerender('dee183b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transaction/components/search.vue"
export default component.exports